import { wencesApi } from "@/api/wencesApi";

/** Rutas del listado de un modelo dinámico: normal, papelera y archivo. */
export const DYNAMIC_MODEL_LIST_ROUTE_NAMES = [
  "DynamicModel",
  "DynamicModelTrash",
  "DynamicModelArchive",
];

/**
 * Guard: el listado de un modelo requiere {modelName}.view.
 * Gestionar también alcanza, igual que para mostrar el modelo en el menú.
 */
export async function hasViewPermissionGuard(to, from, next) {
  try {
    if (localStorage.getItem("role") === "admin") {
      return next();
    }

    const modelName = to.params.modelName;
    if (!modelName) {
      return next("/dashboard");
    }

    const response = await wencesApi.get("/api/users/myprofile");
    if (!response.data.ok) {
      return next("/dashboard");
    }

    const userData = response.data.data;
    const roleId =
      typeof userData.role === "string"
        ? userData.role
        : userData.role && userData.role._id;
    if (!roleId) {
      return next("/dashboard");
    }

    const roleResponse = await wencesApi.get(`/api/roles/${roleId}`);
    const permissions =
      (roleResponse.data.success &&
        roleResponse.data.data &&
        roleResponse.data.data.permissions) ||
      [];

    const m = modelName.toLowerCase();
    const accepted = [
      "all_access",
      `${m}.view`,
      `${m}_view`,
      `${m} - view`,
      `${m}.manage`,
      `${m}_manage`,
    ];
    const allowed = permissions.some((perm) =>
      accepted.includes(String(perm).toLowerCase())
    );

    return allowed ? next() : next("/dashboard");
  } catch (error) {
    console.error("Error verificando permiso de listado:", error);
    next("/dashboard");
  }
}

export default hasViewPermissionGuard;
